module.exports = __webpack_public_path__ + "media/images/icons/side_menu_home_attivo-29833746a0374c3c0a8b0ae17c39b87c.svg";